import { css } from "@emotion/css"

import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import Link from "../../../../../../../components/ui/Link/Link"
import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import { isRigid } from "../../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import LINKS from "../../../../constant/links"
import isValidLayer from "../../../../service/visibleValidator/isValidLayer"

import 片面アルミベース from "./01_1L_alm_base.png"
import _2層アルミベース from "./02_2L_alm_base.png"
import _2層アルミコア from "./03_2L_alm_core.png"
import 片面銅ベース from "./04_1L_cupper_base.png"
import _2層銅ベース from "./05_2L_cupper_base.png"
import _2層銅コア from "./06_2L_cupper_core.png"
import 片面銅ベースポスト from "./07_1L_cupper_base_post.png"
import _2層銅ベースポスト from "./08_2L_cupper_base_post.png"
import _2層銅コアポスト from "./09_2L_cupper_core_post.png"
import image from "./layer.png"

const 構成層数 = ({ values, handlers, errors }: OneClickFieldProps) => {
  return (
    <OneClickField legend="構成層数" helpURL={HELP_LINKS.構成層数} src={image}>
      <RadioGroup
        name={FIELD_NAMES.構成層数}
        selectedValue={values.layer}
        onChange={handlers.radio}
        shouldRender={(value) => isValidLayer(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.構成層数.片面.value}>片面</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層"].value}>2層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["4層"].value}>4層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["6層"].value}>6層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["8層"].value}>8層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["10層"].value}>10層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["12層"].value}>12層</Radio>
          {isRigid(values) && (
            <span className={styles.link}>
              <Link href={LINKS.RIGID_14LAYERS_OR_MORE} target="_blank">
                14層以上はこちら ≫
              </Link>
            </span>
          )}

          <Radio value={ESTIMATE_CONSTANT.構成層数.FPC片面.value}>FPC片面</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数.FPC2層両面.value}>FPC2層両面</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数.FPC3層.value}>FPC3層</Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数.FPC4層.value}>FPC4層</Radio>

          <Radio value={ESTIMATE_CONSTANT.構成層数.片面アルミベース.value} prefixImageSrc={片面アルミベース}>
            片面アルミベース
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層アルミベース"].value} prefixImageSrc={_2層アルミベース}>
            2層アルミベース
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層アルミコア"].value} prefixImageSrc={_2層アルミコア}>
            2層アルミコア
          </Radio>

          <Radio value={ESTIMATE_CONSTANT.構成層数.片面銅ベース.value} prefixImageSrc={片面銅ベース}>
            片面銅ベース
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層銅ベース"].value} prefixImageSrc={_2層銅ベース}>
            2層銅ベース
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層銅コア"].value} prefixImageSrc={_2層銅コア}>
            2層銅コア
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数.片面銅ベースポスト.value} prefixImageSrc={片面銅ベースポスト}>
            片面銅ベースポスト
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層銅ベースポスト"].value} prefixImageSrc={_2層銅ベースポスト}>
            2層銅ベースポスト
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.構成層数["2層銅コアポスト"].value} prefixImageSrc={_2層銅コアポスト}>
            2層銅コアポスト
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.layer} />
    </OneClickField>
  )
}

export default 構成層数

const styles = {
  link: css`
    line-height: 34px;
    a {
      color: #16a34a !important;
    }
  `,
}
